module.exports = __webpack_public_path__ + "static/media/msBlueLogo.cd9c6b3a.svg";